import React from 'react';
import { SimplePage } from '../components/shared/SharedComponents';
import { useContent } from '../hooks/useContent';
import { useScrollToTop } from '../hooks/useScrollToTop';

const Construction = () => {
  useScrollToTop();
  const { construction } = useContent();

  return (
    <SimplePage
      title={construction.title}
      description={construction.description}
    />
  );
};

export default Construction;